
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-menu-toggle class="menu-toggle">
        <ion-button>
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-menu-toggle>
    </ion-buttons>
    <div class="profile-part" slot="end">
      <div class="current-user">
        <div>{{ currentUser?.nom }} {{ currentUser?.prenom }}</div>
        <div class="deco-link" (click)="logout()">{{ 'menu.deconnexion' | translate }}</div>
      </div>
      <img *ngIf="currentUser | userPhotoUrl as photoUrl; else headerPersonIcon" [src]="photoUrl" [routerLink]="'/profile'" class="profil-photo" alt="">
      <ng-template #headerPersonIcon>
        <mat-icon [routerLink]="'/profile'">person</mat-icon>
      </ng-template>
    </div>
    <div class="left-part">
      <div class="logo-bg">
        <div class="logo-img">
        </div>
      </div>
      <ion-title [routerLink]="'/'" >
        {{'appName' | translate}}
      </ion-title>
    </div>
  </ion-toolbar>
  <ion-toolbar class="compte-partage-flag" color="danger" *ngIf="comptePartage !== null">
    <ion-title size="small">
     <div class="compte-partage-title">
        <span>
          {{ 'controleCompteDesc' | translate }} {{ comptePartage.nom }} {{ comptePartage.prenom }}
        </span>
        <ion-icon name="close" (click)="closeComptePartage()"></ion-icon>
     </div>
    </ion-title>
  </ion-toolbar>
